// Single source of truth for product strings used across pages.

// ?start=src_site → bot /start, YENİ kullanıcıya users.acq_source="site" yazar
// (tg/bot_handler._record_acq_source). Etiketsiz link siteden gelen kaydı ölçemez.
export const TELEGRAM_BOT_URL = "https://t.me/AlphaHedgeBot?start=src_site";

// Yerleşim etiketi: src_site_<yer> → acq_source "site_<yer>" — hangi düğmenin
// kayıt getirdiği görünür; "site_" öneki toplamı korur. Telegram start
// parametresi yalnız [A-Za-z0-9_-] ve en fazla 64 karakter kabul eder.
export function telegramBotUrl(placement?: string): string {
  const tag = (placement ?? "").replace(/[^a-z0-9_]/g, "").slice(0, 40);
  return tag ? `${TELEGRAM_BOT_URL}_${tag}` : TELEGRAM_BOT_URL;
}
export const TELEGRAM_BOT_HANDLE = "@AlphaHedgeBot";
export const TWITTER_URL = "https://x.com/AlphaHedgeBot";
export const TWITTER_HANDLE = "@AlphaHedgeBot";
export const PRODUCT_NAME = "AlphaHedge";
